import React, { Component } from 'react';
import './Signin.css'

class Signin extends Component {

    constructor(props){
        super(props);
        this.state = {
            signInEmail:'',
            signInPassword:''
        }
    }

    onEmailChange = (event) => {
        this.setState({signInEmail: event.target.value})
    }

    onPasswordChange = (event) => {
        this.setState({signInPassword: event.target.value})
    }

    onSubmitSignIn = () =>{
        fetch('https://detect-face-server.onrender.com/signin', {
            method: "POST",
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify(
                {
                    email:this.state.signInEmail,
                    password: this.state.signInPassword
                }
            )
        })
            .then(response => response.json())
            .then(user => {
                if (user.user_id)
                {
                    this.props.loadUser(user);
                    this.props.onRouteChange('home')
                }
            })
        
    }

    render(){
        const {onRouteChange} = this.props;
        return (
            <article className="mw6 center  br3 mv4 ba b--black-10 shadow-5 w-100 w-50-m w-50-l">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                        <legend className="f1 fw6 ph0 mh0">Sign In</legend>
                        <div className="mt3">
                            <label className="db fw6 lh-copy f4" htmlFor="email-address">Email</label>
                            <input onChange={this.onEmailChange} className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100" type="email" name="email-address"  id="email-address"/>
                        </div>
                        <div className="mv3">
                            <label className="db fw6 lh-copy f4" htmlFor="password">Password</label>
                            <input onChange={this.onPasswordChange} className="b pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100" type="password" name="password"  id="password"/>
                        </div>
                        </fieldset>
                        <div className="">
                            <input className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f4 dib br3" 
                            type="submit" 
                            value="Sign in"
                            onClick={this.onSubmitSignIn}
                            />
                        </div>
                        <div className="lh-copy mt3">
                            <p  onClick={() => {onRouteChange('register')}} className="f6 link dim black db pointer">Register</p>
                        </div>
                    </div>
                </main>
           </article>
        );
    }


} 

export default Signin;